import { Button, Chip, Stack, Tooltip } from '@mui/material';
import { DataGrid, faIR } from '@mui/x-data-grid';
import { useGetParts } from '../../api/hooks/inventory';
import DICTIONARY from '../../utils/dictionary';
import { downloadFile, toPersianNumber } from '../../utils/helpers';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export default function PartsTable() {
  const { data: parts } = useGetParts();
  return (
    <DataGrid
      columns={columns}
      rows={formatData(parts)}
      rowsPerPageOptions={[10]}
      localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
    />
  );
}

const columns = [
  {
    field: 'guarantee',
    width: 150,
    headerName: 'گارانتی',
    type: 'string',
    sortable: true,
    valueGetter: ({ value }) => DICTIONARY[value],
  },
  {
    field: 'number',
    width: 150,
    headerName: 'شماره پارت',
    type: 'number',
    headerAlign: 'left',
    sortable: true,
    valueFormatter: ({ value }) => toPersianNumber(value),
  },
  {
    field: 'year',
    width: 100,
    headerName: 'سال',
    type: 'number',
    sortable: true,
    headerAlign: 'left',
    valueFormatter: ({ value }) => toPersianNumber(value),
  },
  {
    field: 'completed',
    width: 120,
    headerName: 'وضعیت',
    type: 'boolean',
    sortable: true,
    align: 'center',
    renderCell: ({ value: complated }) => (
      <Tooltip
        title={
          complated
            ? 'تمامی دستگاه‌های این پارت ثبت شده اند.'
            : 'دستگاه‌های این پارت هنوز به طور کامل ثبت نشده اند.'
        }
      >
        <Chip
          variant="outlined"
          size="small"
          color={complated ? 'success' : 'warning'}
          label={complated ? 'کامل' : 'ناقص'}
        />
      </Tooltip>
    ),
  },
  {
    field: 'createdAt',
    width: 150,
    headerName: 'تاریخ ایجاد',
    type: 'date',
    sortable: true,
    align: 'right',
    valueFormatter: ({ value }) => new Date(value).toLocaleDateString('fa-IR'),
  },
  {
    field: 'files',
    width: 280,
    headerName: 'فایل‌ها',
    type: 'string',
    sortable: false,
    renderCell: ({ value }) => (
      <Stack sx={{ width: '100%' }} direction="row" justifyContent="space-around">
        <Button
          variant="secondary"
          disabled={!value.records}
          onClick={() => {
            downloadFile(value.records);
          }}
          endIcon={<InsertDriveFileIcon />}
        >
          اکسل واردات
        </Button>
        <Button
          variant="secondary"
          disabled={!value.hamta}
          onClick={() => {
            downloadFile(value.hamta);
          }}
          endIcon={<InsertDriveFileIcon />}
        >
          همتا
        </Button>
      </Stack>
    ),
  },

  {
    field: 'id',
    width: 100,
    headerName: 'عملیات',
    type: 'string',
    sortable: false,
    renderCell: ({ value }) => (
      <Stack sx={{ width: '100%' }} direction="row" justifyContent="space-around">
        <Button href={`/inventory/parts/${value}`} endIcon={<OpenInNewIcon />}>
          جزئیات
        </Button>
      </Stack>
    ),
  },
];

function formatData(parts) {
  return parts?.map((p) => ({ ...p, files: { records: p.recordsFileAddress } })) ?? [];
}
